'use client';

import { useOptionalRenderContext } from './RenderContextProvider';

/**
 * Marks a section container that must disappear when every block inside it
 * rendered nothing. The rule itself lives in `globals.css` — see the comment
 * there for why this is a CSS decision and not a React one.
 */
export const COLLAPSE_WHEN_EMPTY = 'collapse-when-empty';

/**
 * The collapse class, except in the CMS preview canvas.
 *
 * An editor who has just dropped a section onto a page has an empty section by
 * definition, and one whose only widget hides itself on the previewed Standort
 * still has to be selectable to be edited — collapsing it would take the block
 * action bar and the drop target with it. Every other tree (live, and the
 * `preview-url` draft view, which shows the page as a visitor would get it)
 * collapses.
 *
 * Outside a provider — unit tests — there is no canvas, so the class applies.
 */
export function useCollapseWhenEmpty(): string | undefined {
  const mode = useOptionalRenderContext()?.mode;
  return mode === 'preview-iframe' ? undefined : COLLAPSE_WHEN_EMPTY;
}
